import { render, staticRenderFns } from "./NewMethod.vue?vue&type=template&id=38e9f038&"
import script from "./NewMethod.vue?vue&type=script&lang=js&"
export * from "./NewMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports